class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
  }

  open(triggeredBy) {
    if (this.__deferOpen) return;
    if (this.classList.contains('active')) return;
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    handleScrollOnModalToggle(true, this);
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    handleScrollOnModalToggle(false, this);
    const drawerItems = this.querySelector('cart-drawer-items');
    if (drawerItems) drawerItems.scrollTop = 0;
    const drawerInner = this.querySelector('.drawer__inner');
    if (drawerInner) drawerInner.scrollTop = 0;
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      if (!parsedState.sections || !parsedState.sections[section.id]) return;
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      if (!sectionElement) return;
      const newContent = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      if (newContent) {
        sectionElement.innerHTML = newContent;
      }
    });

    this.updateEmptyState(parsedState);

    setTimeout(() => {
      const overlay = this.querySelector('#CartDrawer-Overlay');
      if (overlay) {
        overlay.addEventListener('click', this.close.bind(this));
      }
      if (this.__deferOpen) return;
      this.open();
      document.body.dispatchEvent(new CustomEvent('flyoutCartOpen'));
      if (document.body.classList.contains('has-optimizely')) detectOptimizelyExperiments();
    });
  }

  updateEmptyState(parsedState) {
    if (typeof parsedState.item_count === 'number') {
      if (parsedState.item_count === 0) {
        this.classList.add('is-empty');
      } else {
        this.classList.remove('is-empty');
      }
    } else {
      this.classList.remove('is-empty');
    }
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const element = doc.querySelector(selector);
    return element ? element.innerHTML.trim() : '';
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    const sections = [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
    if (document.getElementById('cart-cyot')) {
      sections.push({
        id: 'cart-cyot',
        section: 'cart-cyot',
        selector: '.inner',
      });
    }
    return sections;
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
